import React from 'react'

/**
 * Captura erros de renderização em qualquer componente filho e, em vez de
 * deixar a tela totalmente branca (comportamento padrao do React 16 quando
 * um erro nao e capturado), exibe uma mensagem legivel com o detalhe do erro.
 *
 * Isso serve tanto de protecao para o usuario final quanto de ferramenta de
 * diagnostico: o texto do erro e do "component stack" aponta exatamente qual
 * componente/linha quebrou.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, info: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    this.setState({ error, info })
    // Mantem o rastro no console tambem
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] erro capturado:', error, info)
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    const { error, info } = this.state

    return (
      <div
        style={{
          maxWidth: 900,
          margin: '40px auto',
          padding: 24,
          fontFamily: 'monospace',
          background: '#fff5f5',
          border: '1px solid #f5b5b5',
          borderRadius: 8,
          color: '#7a1f1f',
        }}
      >
        <h2 style={{ marginTop: 0 }}>Ops, algo quebrou nesta tela</h2>
        <p style={{ color: '#41494F', fontFamily: 'sans-serif' }}>
          Tente novamente mais tarde. Se o problema persistir, envie o print
          abaixo para o time de tecnologia.
        </p>

        <strong>Erro:</strong>
        <pre style={{ whiteSpace: 'pre-wrap' }}>
          {error && (error.toString() + (error.stack ? '\n\n' + error.stack : ''))}
        </pre>

        {info && info.componentStack && (
          <>
            <strong>Componente:</strong>
            <pre style={{ whiteSpace: 'pre-wrap' }}>{info.componentStack}</pre>
          </>
        )}
      </div>
    )
  }
}

export default ErrorBoundary
